import { render, staticRenderFns } from "./HumanChart.vue?vue&type=template&id=591ced2b&scoped=true&"
import script from "./HumanChart.vue?vue&type=script&lang=ts&"
export * from "./HumanChart.vue?vue&type=script&lang=ts&"
import style0 from "./HumanChart.vue?vue&type=style&index=0&id=591ced2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ced2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('591ced2b')) {
      api.createRecord('591ced2b', component.options)
    } else {
      api.reload('591ced2b', component.options)
    }
    module.hot.accept("./HumanChart.vue?vue&type=template&id=591ced2b&scoped=true&", function () {
      api.rerender('591ced2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/HumanChart.vue"
export default component.exports